(function () {
    const faq = () => {
        const tabBtns = document.querySelectorAll('.c-faq__tab');

        tabBtns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                tabBtns.forEach(otherBtn => {
                    otherBtn.classList.remove('c-faq__tab--active');
                });
                tabBtns[index].classList.add('c-faq__tab--active');
                
                const targetTab = document.getElementById(btn.getAttribute('data-tab'));
                targetTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });
        
    }

document.addEventListener('shopify:section:load', faq);
faq();

})();